module.exports = "/_next/static/chunks/fonts/empty-state-3191addd104af71ea07db21fda23664b.svg";